import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router';

export const initSentry = (app: App, router: Router) => {
  Sentry.init({
    app,
    dsn: "https://62d9e33fb06d052bbe1ac2ba7a6cf55e@o876503.ingest.us.sentry.io/4508963667116032",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false
      })
    ],
    enabled: import.meta.env.MODE !== 'development',
    // Tracing
    tracesSampleRate: 0.25, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/.*sam-calc.*\.com/
    ],
    ignoreTransactions: [
      /^GET \/healthz\/liveness$/,
      'healthz'
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Vue specific
    trackComponents: true,
    release: 'sam-calc-admin@' + import.meta.env.VITE_VERSION,
    environment: import.meta.env.MODE ?? 'unknown'
  });
}

export function attachFeedback() {
  const reportButton = document.querySelector('#report-bug-button')

  if (reportButton) {
    const feedback = Sentry.getFeedback()

    if (feedback) {
      feedback.attachTo(reportButton)
    }
  }
}